import './header-search-featured-card.scss'

import { faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { defineComponent } from 'vue'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { SearchFeaturedCard } from '../search-featured-card'

export const HeaderSearchFeaturedCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sSearchFeaturedCard: SearchFeaturedCard,
    },
    props: ['searchFeatured', 'rounded', 'targetRouteName', 'displayBottom', 'abortPending'],
    template: require('./header-search-featured-card.html'),
    data() {
        return {
            arrowIcon: faCaretUp,
        }
    },
    computed: {
        materialsAndTechniques() {
            if (this.searchFeatured && this.searchFeatured.materialAndTechniques) {
                return this.searchFeatured.materialAndTechniques
            }
            return [];
        },
        measurements() {
            if (this.searchFeatured && this.searchFeatured.measurements) {
                return this.searchFeatured.measurements
            }
            return [];
        },
    },
})
